import React, { useState } from 'react';
import Header from '../../../components/Header';
import OutageRequisitions from './outrageRequisitions';
import { X, AlertCircle } from 'lucide-react';

const OutageRequisition = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Header title={'Outage Requisition'} />
      <div className="flex-1 overflow-auto">
        {/* Error Toast */}
        {errorMessage && (
          <div className="fixed bottom-6 right-6 z-[100] animate-slide-up">
            <div className="bg-red-500 text-white px-6 py-4 rounded-lg shadow-lg flex items-start gap-3 min-w-[320px] max-w-md">
              <AlertCircle size={20} className="flex-shrink-0 mt-0.5" />
              <div className="flex-1">
                <h3 className="font-semibold mb-1">Error</h3>
                <p className="text-sm">{errorMessage}</p>
              </div>
              <button onClick={() => setErrorMessage(null)} className="flex-shrink-0 hover:bg-red-600 rounded p-1 transition-colors">
                <X size={16} />
              </button>
            </div>
          </div>
        )}

        <OutageRequisitions
          onError={(message) => {
            setErrorMessage(message);
            setTimeout(() => setErrorMessage(null), 5000);
          }}
        />
      </div>
    </div>
  );
};

export default OutageRequisition;
